import { FC, Fragment } from 'react';
import FormGroup from 'components/ui/FormGroup/FormGroup';
import { useTranslation } from 'react-i18next';
import { ForwardPickup } from 'ts/transfer/interfaces/TransferResultsResponse';
import { Validation } from 'ts/interfaces/Validation';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface InfoFormAddressProps {
  isSubmitted: boolean;
  type: 'airport' | 'city';
  onChange: (value: ForwardPickup) => void;
  value: ForwardPickup;
  validation: Validation;
}

const InfoFormAddress: FC<InfoFormAddressProps> = ({
  isSubmitted,
  type,
  value,
  onChange,
  validation,
}) => {
  const [t] = useTranslation();
  return (
    <Fragment>
      {type === 'airport' && (
        <Fragment>
          <FormGroup
            value={value.airline}
            onChange={(airline) => onChange({ ...value, airline })}
            label={t('filter.airline')}
            className="col-6 col-md-3"
            isSubmitted={isSubmitted}
            validation={validation.airline}
          />
          <FormGroup
            value={value.flightNumber}
            onChange={(flightNumber) => onChange({ ...value, flightNumber })}
            label={t('flight.number')}
            className="col-6 col-md-3"
            isSubmitted={isSubmitted}
            validation={validation.flightNumber}
          />
        </Fragment>
      )}

      {type === 'city' && (
        <FormGroup
          value={value.address}
          onChange={(address) => onChange({ ...value, address })}
          label={t('flight.additional_info')}
          className="col-12 col-md-6"
          isSubmitted={isSubmitted}
          validation={validation.address}
        />
      )}
    </Fragment>
  );
};

export default withErrorBoundary(InfoFormAddress, 'InfoFormAddress');
